import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "img-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "logo-placeholder"
}
const _hoisted_4 = {
  key: 0,
  class: "file-drop file-drop--image"
}
const _hoisted_5 = ["accepts"]
const _hoisted_6 = {
  class: "file-drop--image__label",
  for: "imageFileDrop"
}
const _hoisted_7 = { class: "filetypes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_trash_icon = _resolveComponent("trash-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["logo-container", {value: _ctx.editing, editing: _ctx.editing}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.logo
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_q_icon, {
              class: "camera-icon",
              name: "photo_camera",
              size: "2rem"
            })
          ]))
    ]),
    (_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("input", {
            class: "file-drop--image__input",
            type: "file",
            id: "imageFileDrop",
            accepts: _ctx.accepts,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
            onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
            onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
            ref: "imageInput"
          }, null, 40, _hoisted_5),
          _createElementVNode("label", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Choose a different logo", -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.accepts.join(' / ')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.editing)
      ? (_openBlock(), _createBlock(_component_trash_icon, {
          key: 1,
          class: "trash-icon",
          size: "20px",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove-logo')))
        }))
      : _createCommentVNode("", true)
  ], 2))
}